import React, { useState } from "react";
import { X } from "lucide-react";
import "./NewFeaturesBanner.css";

const NewFeaturesBanner = ({ onDismiss, onOpenDetails }) => {
    const [isLeaving, setIsLeaving] = useState(false);

    const handleDismiss = (e) => {
        e.stopPropagation();
        setIsLeaving(true);
        setTimeout(() => onDismiss?.(), 240);
    };

    const handleClick = () => {
        if (isLeaving) return;
        onOpenDetails?.();
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            className={`nf-banner ${isLeaving ? "nf-banner--leaving" : ""}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label="Ver novedades del release"
        >
            <span className="nf-banner__mark" aria-hidden="true">✦</span>

            <span className="nf-banner__text">
                <span className="nf-banner__kicker">Novedades</span>
                <span className="nf-banner__message">
                    <span className="nf-banner__feat">Búsqueda con IA</span>
                    <span className="nf-banner__sep">·</span>
                    <span className="nf-banner__feat">Posteos</span>
                    <span className="nf-banner__sep">·</span>
                    <span className="nf-banner__feat">Calificaciones</span>
                </span>
            </span>

            <span className="nf-banner__link" aria-hidden="true">
                Ver más <span className="nf-banner__arrow">→</span>
            </span>

            <button
                className="nf-banner__close"
                onClick={handleDismiss}
                aria-label="Cerrar banner"
                type="button"
            >
                <X size={15} />
            </button>
        </div>
    );
};

export default NewFeaturesBanner;
